import { connect } from "react-redux";

import { switchEditMode, selectEditMode } from "~/store/ducks/application/annotations";

import {
  toggleAnnotations,
  selectIsAnnotationsVisible,
  selectShowCutout,
  toggleCutoutShow,
  toggleModalCutoutShow
} from "~/store/ducks/user/uistate";
import {
  selectShowCursorDefaultButton,
  selectShowAnnotationsShowHideButton,
  selectShowEditModeButton,
  selectShowColorPickerButton,
  selectShowDeleteButton,
  selectShowCutoutButton,
  selectShowDeleteAllButton
} from "~/store/ducks/domain/ui/menu";
import { showModal } from "~/store/ducks/domain/ui/modal";

import {
  setDrawingMode,
  toggleDrawingMode,
  selectIsDrawingMode,
  selectShapeType,
  setShapeType
} from "~/store/ducks/application/fabric";

import { deleteSelected, deleteAllAnnotations } from "~/store/ducks/user/annotations";
import { selectMaterialsByCategoryAndTabSorted } from "~/store/selectors/dls";
import AnnotationeerControls from "./AnnotationeerControls";

function mapStateToProps(state) {
  return {
    showCursorDefaultButton: selectShowCursorDefaultButton(state),
    showAnnotationsShowHideButton: selectShowAnnotationsShowHideButton(state),
    showEditModeButton: selectShowEditModeButton(state),
    showColorPickerButton: selectShowColorPickerButton(state),
    showDeleteButton: selectShowDeleteButton(state),
    isAnnotationsVisible: selectIsAnnotationsVisible(state),
    editMode: selectEditMode(state),
    isDrawingMode: selectIsDrawingMode(state),
    shapeType: selectShapeType(state),
    showCutout: selectShowCutout(state),
    showCutoutButton: selectShowCutoutButton(state),
    showDeleteAllButton: selectShowDeleteAllButton(state),
    materials: selectMaterialsByCategoryAndTabSorted(state)
  };
}

const mapDispatchToProps = {
  setDrawingMode,
  toggleAnnotations,
  switchEditMode,
  toggleDrawingMode,
  setShapeType,
  deleteSelected,
  deleteAllAnnotations,
  showModal,
  toggleCutoutShow,
  toggleModalCutoutShow
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnotationeerControls);
